import { QueryClient } from "@tanstack/react-query"

const queryErrorHandlers = (error: unknown) => {
    // eslint-disable-next-line
    const title =
        error instanceof Error
            ? error.message
            : 'Something went wrong. Please try again or contact your system administrator.'
}

export const defaultQueryClientOptions = {
    queries: {
        onError: queryErrorHandlers,
        staleTime: 600000, // 10 minutes
        cacheTime: 180000, // 3 minutes; cacheTime should not exceed staleTime
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: false
    },
    mutations: {
        onError: queryErrorHandlers
    }
}

export const queryClient = new QueryClient({
    defaultOptions: defaultQueryClientOptions
})